import { i18n } from 'next-i18next'

// Define a type for the global object with our custom properties
interface GlobalWithI18n extends Global {
  i18nInstance?: typeof i18n
  i18n?: typeof i18n
}

// Type assertion for the global object
const globalWithI18n = global as unknown as GlobalWithI18n

/**
 * Translates a given key to the corresponding localized string.
 *
 * @param {string} key - The translation key to look up.
 * @param {string} [defaultValue] - The default value to return if the key is not found.
 * @param {object} [options] - Additional options for the translation (e.g., interpolation values).
 * @returns {string} The translated string or the default value/key if translation is not available.
 */
export const translate = (
  key: string,
  defaultValue?: string,
  options?: Record<string, unknown>,
): string => {
  // Use the global i18nInstance if available (for test environment)
  const i18nInstance = globalWithI18n.i18nInstance || globalWithI18n.i18n || i18n

  // Check if i18n is initialized
  if (!i18nInstance?.t) {
    console.warn('i18n not initialized')

    // Return the default value or the key itself if i18n is not available
    return defaultValue || key
  }

  // Use i18n to translate the key, passing along any default value and options
  return i18nInstance.t(key, { defaultValue, ...options })
}
